import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Signature on-load reveal: each line is masked and rises into place.
// Renders real text nodes (indexable) and snaps to final state under
// prefers-reduced-motion.
export default function MaskText({ lines = [], className = "", delay = 0, accentIndex = -1, accentClassName = "text-etap-primary" }) {
  const reduce = useReducedMotion();

  const renderLine = (line, i) => {
    const isAccent = i === accentIndex;
    const content = <span className={isAccent ? accentClassName : ""}>{line}</span>;

    if (reduce) {
      return (
        <span key={i} className="block">
          {content}
        </span>
      );
    }
    return (
      <span key={i} className="block overflow-hidden pb-[0.22em] -mb-[0.12em]">
        <motion.span
          className="block will-change-transform"
          initial={{ y: "115%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.85, delay: delay + i * 0.12, ease: EASE }}
        >
          {content}
        </motion.span>
      </span>
    );
  };

  return <span className={className}>{lines.map(renderLine)}</span>;
}
